import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Leaderboard } from "@/components/site/Leaderboard";
import { Bento } from "@/components/site/Bento";
import { FinalCta } from "@/components/site/FinalCta";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, anchors: true });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);

  return (
    <div className="site grain">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Leaderboard />
        <Bento />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}

export default App;
